import { render } from "./CourtExpensesTable.vue?vue&type=template&id=6a5578d0&scoped=true"
import script from "./CourtExpensesTable.vue?vue&type=script&lang=js"
export * from "./CourtExpensesTable.vue?vue&type=script&lang=js"

import "./CourtExpensesTable.vue?vue&type=style&index=0&id=6a5578d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5578d0"]])

export default __exports__